import { createTheme } from '@mui/material/styles'

import { componentOverrides } from '@/themes/themeOverrides'
import {
  blue,
  darkMode,
  green,
  lightMode,
  semantic,
  spacing,
  SPACING_BASE_UNIT,
  typographyVariants
} from '@/themes/tokens'

declare module '@mui/material/styles' {
  interface Theme {
    tokens: {
      spacing: typeof spacing
    }
  }
  interface ThemeOptions {
    tokens?: {
      spacing?: typeof spacing
    }
  }
}

/**
 * Build the theme for a colour mode.
 *
 * Mirrors untool-mage's theme so the two internal staff tools look like one
 * family. The initial mode follows the submitter's `prefers-color-scheme`, and
 * ThemeToggle in the header lets them switch it.
 */
export const getTheme = (mode: 'light' | 'dark') => {
  const colors = mode === 'light' ? lightMode : darkMode

  return createTheme({
    cssVariables: true,
    tokens: { spacing },
    palette: {
      mode,
      primary: blue,
      secondary: green,
      success: semantic.success,
      error: semantic.error,
      warning: semantic.warning,
      info: semantic.info,
      background: colors.background,
      text: colors.text,
      divider: colors.divider
    },
    typography: {
      ...typographyVariants,
      htmlFontSize: 14 // 1rem = 14px, set on :root in index.html
    },
    spacing: SPACING_BASE_UNIT,
    components: componentOverrides
  })
}
